import type LegacyModal from '@orientaction/components/ModalCardSens';
import { ComponentProps } from 'react';
import DetailModal, { Advice, ContentList, Html } from '.';
import { useDetailModalStyles } from './DetailModal.styles';

const MeaningDetailModal = (props: ComponentProps<typeof LegacyModal>) => {
  const { open, onCancel, img, color } = props;
  const { sens, longText, text1, text2, text3, text4, listeAccordeon, listEmploi1, listEmploi2 } =
    props;
  const classes = useDetailModalStyles();
  return (
    <DetailModal
      open={open}
      onCancel={onCancel}
      label={sens.label}
      img={img}
      color={color}
      value={sens.score}
      introduction={
        <>
          <h3>{sens.description[0]}</h3>
          <Html text={longText} />
        </>
      }>
      <section className={classes.panel} style={{ backgroundColor: color }}>
        <h2>Les conseils de carrière d’Orientaction</h2>
        <Html text={text1} />
        <div className={`${classes.columns} ${classes.accordions}`}>
          {listeAccordeon?.map((item: any, index: number) => (
            <Advice key={item.title} index={index + 1} title={item.title}>
              <Html text={item.description} />
            </Advice>
          ))}
        </div>
        <p style={{ marginTop: 24 }}>
          <strong>{text2}</strong>
        </p>
        <div className={classes.border}>
          <h2>Liste des métiers en lien avec cette valeur</h2>
          <Html text={text3} />
          <div className={classes.columns}>
            <ContentList items={listEmploi1} />
            <ContentList items={listEmploi2} />
          </div>
          <p style={{ marginTop: 20 }}>{text4}</p>
        </div>
      </section>
    </DetailModal>
  );
};

export default MeaningDetailModal;
